import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private _loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  isLoading(): Observable<boolean> {
    return this._loading.asObservable();
  }

  showLoading() {
    this._loading.next(true);
  }

  dismissLoading() {
    this._loading.next(false);
  }
}
